module.exports = __webpack_public_path__ + "img/logo_mzcx2.9b512ae8.png";